(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hundy-all-joy-card"] && !Shopify.designMode) return;
  try {
    
  const playHundyAllJoyAnimation = (artwork) => {
    const image = artwork.querySelector('.hundy-all-joy-card__image');

    const reveal = () => {
      artwork.classList.remove('is-visible');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => artwork.classList.add('is-visible'));
      });
    };

    if (image.complete) {
      reveal();
    } else {
      image.addEventListener('load', reveal, { once: true });
      image.addEventListener('error', () => artwork.classList.add('is-visible'), { once: true });
    }
  };

  const initHundyAllJoyCards = () => {
    const artworks = document.querySelectorAll('.hundy-all-joy-card__artwork:not([data-animation-ready])');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    artworks.forEach((artwork) => {
      artwork.dataset.animationReady = 'true';

      if (reduceMotion || !('IntersectionObserver' in window)) {
        artwork.classList.add('is-visible');
        return;
      }

      if (window.Shopify && window.Shopify.designMode) {
        playHundyAllJoyAnimation(artwork);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (window.scrollY === 0 && entry.target.getBoundingClientRect().top > 0) {
                window.addEventListener(
                  'scroll',
                  () => playHundyAllJoyAnimation(entry.target),
                  { once: true, passive: true }
                );
              } else {
                playHundyAllJoyAnimation(entry.target);
              }

              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.45 }
      );

      observer.observe(artwork);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHundyAllJoyCards, { once: true });
  } else {
    initHundyAllJoyCards();
  }

  document.addEventListener('shopify:section:load', initHundyAllJoyCards);
  document.addEventListener('shopify:section:select', (event) => {
    const artwork = event.target.querySelector('.hundy-all-joy-card__artwork');

    if (artwork && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      playHundyAllJoyAnimation(artwork);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hundy-conversion-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let frame = null;

    function updateParallax() {
      frame = null;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const viewportHeight = window.innerHeight;
      document.querySelectorAll('.hundy-hero--parallax').forEach((hero) => {
        const media = hero.querySelector('.hundy-hero__media');
        if (!media) return;
        if (reduceMotion) {
          media.style.transform = '';
          return;
        }
        const rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;
        const distance = viewportHeight / 2 - (rect.top + rect.height / 2);
        const offset = Math.max(-75, Math.min(75, distance * 0.12));
        media.style.transform = `translate3d(0, ${offset}px, 0)`;
      });
    }

    function scheduleUpdate() {
      if (frame === null) frame = requestAnimationFrame(updateParallax);
    }

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('DOMContentLoaded', scheduleUpdate);
    scheduleUpdate();
  })();

  } catch(e) { console.error(e); }
})();
})();
